import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import copy from 'copy-to-clipboard';
import AlertMessage from 'components/AlertMessage';
import copyIcon from 'images/copy.svg';

class CurrentPlan extends Component {
  state = {
    showAlert: false,
  };

  handleCopy = e => {
    e.preventDefault();
    const text = this.refs['ref-link'].value;
    copy(text);
    this.toggleAlert();
    setTimeout(() => this.toggleAlert(), 4000);
  };

  toggleAlert = () => {
    this.setState({ showAlert: !this.state.showAlert });
  };

  render() {
    const { aff_dashboard_url, aff_referral_url } = this.props.details;

    const { showAlert } = this.state;

    return (
      <Fragment>
        {showAlert && <AlertMessage text="Your link copied to clipboard!" />}
        <h2 className="h2-title">Your affiliate link</h2>
        <div className="separator-line" />
        <div className="cr-plan">
          <div className="cr-plan-top__row">
            <div style={{ position: 'relative' }}>
              <div
                onClick={this.handleCopy}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '10px',
                  cursor: 'pointer',
                }}>
                <img src={copyIcon} alt="copy to clipboard" />
              </div>
              <input
                ref="ref-link"
                type="text"
                value={aff_referral_url}
                className="form-input input-border form-control"
                style={{ minWidth: '400px' }}
              />
            </div>
            <div>
              <a
                href={aff_dashboard_url}
                target="_blank"
                style={{
                  lineHeight: '1.05',
                }}
                className="btn btn-blue">
                Affiliate dashboard
              </a>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateProps(state) {
  return {
    details: state.details.user,
  };
}

export default connect(mapStateProps)(withRouter(CurrentPlan));



// WEBPACK FOOTER //
// ./src/scenes/Profile/AffiliateDetails.js